<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="90%" :before-close="handleClose"
    :append-to-body="true" :close-on-click-modal="false">
    <div v-show="pageIndex == 1">
      <div>
        <div class="wrap">
          <div class="colorWrap">
            <div v-for="(item, index) in colorTitleList" :key="index" :style="{ color: item.color }" :class="[
              index != colorTitleList.length - 1 ? 'color-item color' : 'color',
              checkTabKey == item.id ? 'tab_active' : '',
            ]" @click="() => checkTab(item)">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div v-if="checkTabKey != null">
          <div class="select-date-wrap">
            <span style="width: 55px">Date：</span>
            <el-date-picker v-model="book_date" :picker-options="expireTimeOPtion" type="date" format="MM/dd/yyyy"
              placeholder="select" value-format="yyyy-MM-dd" @change="changeDate">
            </el-date-picker>
          </div>

          <div v-if="book_date">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
                <div v-if="block && block.block_date" class="block_wrap">
                  <div class="block_title">BLOCK DAY</div>
                  <div class="block_remark">{{ block.block_date }}</div>
                </div>
                <div v-else>
                  <div class="time-wrap" v-if="roomListInfo.length">
                    <!-- <div v-for="(item, index) in roomListInfo" :key="index" class="time-sigle">
                      <div v-for="(citem, cindex) in item.children" :key="cindex" :class="[
                          citem.id == checkTimeId
                            ? 'active time-title'
                            : 'time-title',
                          citem.is_calendar == 1 ? 'is_calendar' : '',
                        ]" :style="{ color: color }" @click="() => checkTime(citem, item)">
                        {{ item.name }} {{ citem.time }}
                      </div>
                    </div> -->
                    <div v-for="(item, index) in roomListInfo" :key="index"
                      :class="item.room_count == 0 ? 'time-sigle-disibled time-sigle' : item.id == checkId ? 'active time-sigle' : 'time-sigle'"
                      @click="() => checkTime(item.room_list[0], item)">
                      <div>
                        <div>{{ item.room_count }} left</div>
                        <div class="room_time">{{ item.time_text }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="LEVEL-DETAIL level-big is-hidden-tablet-992" v-if="detail"
                  :style="{ background: color ? color : '' }">
                  <div class="level-name">{{ detail.title }}</div>
                  <div class="level-price">${{ detail.price }}</div>
                  <div class="html_info no-wrap" v-html="detail.desc"></div>
                  <div class="HR"></div>
                  <div class="html_info no-wrap" v-html="detail.price_info"></div>
                  <div class="HR"></div>
                  <div class="html_info no-wrap" v-html="detail.enable_info"></div>
                  <div class="HR"></div>
                  <div class="no-wrap">
                    {{ detail.remark }}
                  </div>
                </div>
                <el-form ref="form" :rules="rules" :model="form" label-width="120px">
                  <el-form-item prop="first_name" label="First name: ">
                    <el-input size="medium" v-model="form.first_name" placeholder="First name" />
                  </el-form-item>
                  <el-form-item prop="last_name" label="Last name: ">
                    <el-input size="medium" v-model="form.last_name" placeholder="Last name" />
                  </el-form-item>
                  <el-form-item prop="phone" label="Phone：">
                    <el-input size="medium" v-model="form.phone" @input="formatPhoneNumberInfo"
                      placeholder="(201)555-0123" maxlength="13" />
                  </el-form-item>
                  <el-form-item prop="email" label="Email：">
                    <el-input size="medium" v-model="form.email" />
                  </el-form-item>
                  <el-form-item prop="birthday_child_name" label="Birthday Child's Name：" class="child_name label_100">
                    <el-input size="medium" v-model="form.birthday_child_name" placeholder="Birthday Child's Name" />
                  </el-form-item>
                  <el-form-item prop="payment_id" label="Payment: ">
                    <el-radio-group size="medium" v-model="form.payment_id">
                      <el-radio-button v-for="(item, index) in paymentInfo" :key="index" :label="item.id"
                        :value="item.id">{{ index == 0 ? 'deposit ' : 'pay in full ' }} $ {{ item.price
                        }}</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item prop="party_provide_id" class="label_100 provide"
                    label="Would you like us to provide cups, plates, and utensils?">
                    <el-radio-group size="medium" v-model="form.party_provide_id">
                      <el-radio v-for="(item, index) in provideInfo" :key="index" :label="item.id" :value="item.id">{{
                        item.title }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item prop="tablecloth_color_id" label="Select tablecloth color:" class="label_100">
                    <el-radio-group size="medium" v-model="form.tablecloth_color_id">
                      <el-radio v-for="(item, index) in tableclothColorInfo" :key="index" :label="item.id"
                        :value="item.id">{{ item.color }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <!-- <el-form-item prop="birthday_child_name" label="Birthday Child's Name："
                    class="child_name is-hidden-mobile">
                    <el-input size="medium" v-model="form.birthday_child_name" placeholder="Birthday Child's Name" />
                  </el-form-item>
                  <el-form-item prop="remark" label="Remark：" class="label_80">
                    <el-input size="medium" type="textarea" v-model="form.remark" placeholder="order's remark ..." />
                  </el-form-item> -->
                </el-form>
              </el-col>
              <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10" class="is-hidden-mobile-992">
                <div class="LEVEL-DETAIL level-big" v-if="detail" :style="{ background: color ? color : '' }">
                  <div class="level-name">{{ detail.title }}</div>
                  <div class="level-price">${{ detail.price }}</div>
                  <div class="html_info" v-html="detail.desc"></div>
                  <div class="HR"></div>
                  <div class="html_info" v-html="detail.price_info"></div>
                  <div class="HR"></div>
                  <div class="html_info" v-html="detail.enable_info"></div>
                  <div class="HR"></div>
                  <div class="">
                    {{ detail.remark }}
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Close</el-button>
        <!-- <el-button type="primary" @click="submit" :loading="loading">Booking</el-button> -->
        <el-button type="primary" @click="next(1)">Next</el-button>
      </span>
    </div>
    <!-- Second Page -->
    <div v-show="pageIndex == 2">
      <div style="padding: 0 20px 20px 20px">
        <el-row :gutter="10" style="margin-top: 10px">
          <el-col :lg="14" :md="14" :sm="24" :xl="14" :xs="24">
            <div class="base-info">
              <div class="card-title">Your Party Info</div>
              <div class="card">
                <div class="flex space_between">
                  <div>{{ form.first_name }} {{ form.last_name }}</div>
                  <div class="flex">
                    {{ form.payment_id.indexOf('deposit') > -1 ? 'deposit' : 'pay in full' }}
                    <span v-if="form.payment_id.indexOf('deposit') > -1" class="ml10">
                      <!-- ${{ paymentInfo && paymentInfo.find(item => item.id == form.payment_id).price }} -->
                      ${{ getPartyPrice() }}
                    </span>
                    <div class="flex ml10" v-else>
                      <div class="flex" v-if="activity_discount.discount">
                        <span class="discount_price">${{ paymentInfo && (getPartyPrice() *
                          (100 - activity_discount.discount) /
                          100).toFixed(2) }}</span>
                        <span class="org_price">${{ getPartyPrice() }}</span>
                        <div class="discount">-{{ activity_discount.discount }}%</div>
                      </div>
                      <span v-else>
                        ${{ getPartyPrice() }}
                      </span>
                    </div>
                  </div>
                </div>
                <div>{{ form.phone }}</div>
                <div>{{ form.email }}</div>
                <div>{{ detail && detail.title }} {{ book_date_mm }} {{ checkTimeText }}</div>
                <div>Birthday Child's Name：{{ form.birthday_child_name }}</div>
                <div>Would you like us to provide cups, plates, and utensils? {{ getProvideInfoTitle() }}</div>
                <div>Select tablecloth color：{{ getTableclothColorInfoColor() }} </div>
              </div>
            </div>
            <!-- form.payment_id == 0 是定金 -->
            <div>
              <div v-if="additional_service_list.length > 0 || product_payment_list.length > 0" class="card-title">
                Additional service</div>
              <div class="card" v-if="additional_service_list.length">
                <div class="card-content">
                  <div class="tips">*Payment is subject to actual arrival at the store.</div>
                  <div>Estimated ${{ additionalTotal }}</div>
                </div>
                <!-- 免费 -->
                <div class="scrollWrap">
                  <div class="card-content" v-for="(item, index) in additional_service_list" :key="index">
                    <div class="flex">
                      <!-- 有折扣 -->
                      <div v-if="item && item.activity_discount && item.activity_discount.discount">
                        <div class="discount_price">${{ (Number(item.price) * (100 - item.activity_discount.discount) /
                          100).toFixed(2) }}</div>
                        <div class="org_price">${{ item.price }}</div>
                        <div class="discount">-{{ item.activity_discount.discount }}%</div>
                      </div>
                      <!-- 无折扣 -->
                      <div v-else>
                        ${{ item.price }}
                      </div>

                      / {{ item.name }}
                    </div>
                    <el-input-number size="small" v-model="item.num" :min="0" @change="changeNum"></el-input-number>
                  </div>
                </div>
              </div>
              <!-- 收费 -->
              <div class="card" v-if="product_payment_list.length">
                <div class="text-r">
                  <template
                    v-if="product_payment_list.filter(item => item.activity_discount && item.activity_discount.discount && item.num > 0).length > 0">
                    <!-- has discount -->
                    Payment <span class="discount_price_1">${{ paymentTotal }}</span> <span class="org_price_1">${{
                      orgPaymentTotal }}</span>
                  </template>
                  <template v-else>
                    Payment ${{ paymentTotal }}
                  </template>
                </div>
                <div class="scrollWrap">
                  <div class="card-content" v-for="(item, index) in product_payment_list" :key="index">
                    <div class="flex">
                      <!-- 有折扣 -->
                      <div class="flex" v-if="item && item.activity_discount && item.activity_discount.discount">
                        <div class="discount_price">${{ (Number(item.price) * (100 - item.activity_discount.discount) /
                          100).toFixed(2) }}</div>
                        <div class="org_price">${{ item.price }}</div>
                        <div class="discount">-{{ item.activity_discount.discount }}%</div>
                      </div>
                      <!-- 无折扣 -->
                      <div v-else>
                        ${{ item.price }}
                      </div>
                      / {{ item.name }}
                    </div>
                    <el-input-number size="small" v-model="item.num" :min="0" @change="changeNum"></el-input-number>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 10px">
              <div class="card-title">Remark</div>
              <div>
                <el-input v-model="form.remark" placeholder="order's remark ..." size="medium" type="textarea"
                  white-space="pre-line" />
              </div>
            </div>

          </el-col>
          <el-col :lg="10" :md="10" :sm="24" :xl="10" :xs="24">
            <div class="LEVEL-DETAIL" :style="`background: ${color}`">
              <div class="level-name">{{ detail && detail.title }}</div>
              <div class="flex space_between">
                <div>{{ book_date_mm }} {{ checkTimeText }}</div>
                <div>
                  <!-- deposit $50.00 -->
                  {{ form.payment_id.indexOf('deposit') > -1 ? 'deposit' : 'pay in full' }}
                  <span v-if="form.payment_id.indexOf('deposit') > -1">
                    ${{ getPartyPrice() }}
                  </span>
                  <span v-else>
                    <span v-if="activity_discount.discount">
                      <span class="discount_price">${{ (getPartyPrice() *
                        (100 - activity_discount.discount) /
                        100).toFixed(2) }}</span>
                      <span class="org_price">${{ getPartyPrice() }}</span>
                    </span>
                    <span v-else>
                      ${{ getPartyPrice() }}
                    </span>
                  </span>
                </div>
              </div>
              <div>{{ getTableclothColorInfoColor() }} tablecloth</div>
              <div class="HR"></div>
              <div>
                <div v-for="(item, index) in product_payment_list" :key="index" class="mb4">
                  <div v-if="item.num > 0" class="flex space_between">
                    <div class="flex">
                      <!-- 有折扣 -->
                      <div class="flex" v-if="item && item.activity_discount && item.activity_discount.discount">
                        <div class="discount_price">${{ (Number(item.price) * (100 - item.activity_discount.discount)
                          /
                          100).toFixed(2) }}</div>
                        <div class="org_price">${{ item.price }}</div>
                        <div class="discount">-{{ item.activity_discount.discount }}%</div>
                      </div>
                      <!-- 无折扣 -->
                      <div v-else>
                        ${{ item.price }}
                      </div>
                      / {{ item.name }} ({{ item.num }})
                    </div>
                    <div>
                      <!-- discount -->
                      <div v-if="item.activity_discount && item.activity_discount.discount">
                        <span class="discount_price">${{ ((Number(item.price) * (100 - item.activity_discount.discount)
                          /
                          100).toFixed(2) * item.num).toFixed(2) }}</span>
                        <!-- org_price -->
                        <span class="org_price">${{ (item.price * item.num).toFixed(2) }}</span>
                      </div>
                      <div v-else>
                        <span>${{ (item.price * item.num).toFixed(2) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="HR" v-if="product_payment_list.filter(item => item.num > 0).length > 0"></div>
              <div>
                <div v-for="(item, index) in additional_service_list" :key="index" class="mb4">
                  <div v-if="item.num > 0" class="flex space_between">
                    <div class="flex">
                      <div>
                        ${{ item.price }}
                      </div>
                      / {{ item.name }} ({{ item.num }})
                    </div>
                    <div>
                      Pay in store
                    </div>
                  </div>
                </div>
                <div class="tips" v-if="additional_service_list.filter(item => item.num > 0).length > 0">
                  *Payment is subject to actual arrival at the store.</div>
              </div>
              <div class="HR" v-if="additional_service_list.filter(item => item.num > 0).length > 0"></div>
              <div class="flex total space_between">
                <span class="title">Subtotal</span>
                <div v-if="activity_discount.discount || (orgPaymentTotal != paymentTotal)">
                  <span v-if="form.payment_id.indexOf('deposit') > -1" class="discount_price">
                    ${{ (Number(getPartyPrice() || 0) + Number(paymentTotal || 0)).toFixed(2) }}
                  </span>
                  <span v-else class="discount_price">
                    ${{ (Number(getPartyPrice() || 0) * ((100 -
                    (activity_discount.discount || 0)) /
                    100).toFixed(2) + Number(paymentTotal || 0)).toFixed(2) }}
                  </span>
                  <span class="org_price"
                    v-if="form.payment_id.indexOf('deposit') == -1 || (orgPaymentTotal != paymentTotal)">
                    ${{ (Number(getPartyPrice()) + Number(orgPaymentTotal)).toFixed(2)
                    }}
                  </span>
                </div>
                <div v-else>
                  ${{ (Number(getPartyPrice()) + Number(orgPaymentTotal)).toFixed(2) }}
                </div>
              </div>
              <div class="flex total space_between">
                <span class="title">Taxes</span>
                <div>${{ getTaxes('Taxes') }}</div>
              </div>
              <div class="flex total space_between">
                <span class="title">Total</span>
                <div>${{ getTaxes('total') }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Back(2)">Back</el-button>
        <el-button type="primary" @click="next(2)">next</el-button>
      </span>
    </div>
    <!-- Last Page -->
    <div v-show="pageIndex == 3">
      <div style="padding: 0px 20px 20px 20px" class="pay_wrap">
        <el-row :gutter="10" style="margin-top: 10px">
          <el-form ref="payform" :model="payform" :rules="payrules" label-width="140px">
            <el-form-item label="Card Number：" prop="card_number">
              <el-input v-model="payform.card_number" placeholder="Card Number" size="medium" style="width: 300px" />
            </el-form-item>
            <el-form-item label="Expiration Date：" prop="month">
              <!-- <el-date-picker v-model="payform.expiration_date" type="month" format="MM/yyyy" placeholder="select"
                value-format="yyyy-MM" :picker-options="pickerOptions" style="width: 300px">
              </el-date-picker> -->
              <div style="width: 300px; display: flex" class="month_wrap">
                <el-form-item label="" prop="month" label-width="0">
                  <el-select v-model="payform.month" placeholder="Month" @change="changeMonthYear">
                    <el-option v-for="month in 12" :key="month" :label="month" :value="month"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="" prop="year" style="margin-left: 10px" label-width="0">
                  <el-select v-model="payform.year" placeholder="Year" @change="changeMonthYear">
                    <el-option v-for="year in yearOptions" :key="year" :label="year" :value="year"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="tips">{{tips}}</div>
            </el-form-item>
            <el-form-item label="Security code(CVV/CVC)：" prop="card_code">
              <el-input v-model="payform.card_code" placeholder="Security code(CVV/CVC)" size="medium"
                style="width: 300px" maxlength="4" />
            </el-form-item>
            <!-- <el-form-item label="First Name：" prop="first_name">
              <el-input v-model="payform.first_name" placeholder="First Name" size="medium" />
            </el-form-item>
            <el-form-item label="Last Name：" prop="last_name">
              <el-input v-model="payform.last_name" placeholder="Last Name" size="medium" />
            </el-form-item> -->
          </el-form>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Back(3)">Back</el-button>
        <el-button type="primary" @click="submit" :loading="loading">Booking</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment";
import moment_timezone from 'moment-timezone';
import store from "@/store";
import {
  colorTypeList,
  tableclothColor,
  provide,
  roomList,
  productServiceList,
  addBook,
  payment,
  partyPackageDetail,
  bookDetail,
  bookConfig,
} from "@/server/book.js";
export default {
  props: {
    dialogVisible: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  data() {
    return {
      loading: false,
      book_date: null,
      book_date_mm: null,
      yearOptions: [],
      expireTimeOPtion: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > Date.now() + (180 - 1) * 8.64e7;
        },
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      WarningVisible: false,
      form: {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        payment_id: [],
        party_provide_id: null,
        tablecloth_color_id: null,
        birthday_child_name: "",
        remark: "",
      },
      rules: {
        first_name: [
          {
            required: true,
            trigger: "blur",
            message: "First name is required.",
          },
        ],
        last_name: [
          {
            required: true,
            trigger: "blur",
            message: "Last name is required.",
          },
        ],
        phone: [
          {
            required: true,
            trigger: "change",
            validator: this.validatePhone
          },
        ],
        email: [
          {
            required: true,
            type: "email",
            trigger: "blur",
            message: "Please input correct email address.",
          },
        ],
        payment_id: [{ required: true, trigger: "blur", message: "please select one from above" }],
        party_provide_id: [{ required: true, trigger: "blur", message: "please select one from above" }],
        tablecloth_color_id: [{ required: true, trigger: "blur", message: "please select one from above" }],
        birthday_child_name: [{ required: true, trigger: "blur", message: "birthday child name is required" }],
      },
      block: null,
      roomListInfo: [],
      checkId: null,
      checkTimeId: null,
      colorTitleList: [],
      checkTabKey: null,
      color: null,
      provideInfo: [],
      tableclothColorInfo: [],
      paymentInfo: [],
      cancel_reason: null,
      detail: null,
      colorOrgList: ["#faca49", "#de4c50", "#5c7dce"],
      pageIndex: 1,
      checkTimeText: null,
      activity_discount: [],
      additional_service_list: [],
      product_payment_list: [],
      additionalTotal: 0,
      paymentTotal: 0,
      orgPaymentTotal: 0,
      payform: {
        card_number: null,
        // expiration_date: null,
        month: null,
        year: null,
        card_code: null,
        // first_name: null,
        // last_name: null,
      },
      payrules: {
        card_number: [
          {
            required: true,
            trigger: "blur",
            message: "Card Number is required.",
          },
        ],
        month: [
          {
            required: true,
            trigger: "change",
            message: "Month is required.",
          },
        ],
        year: [
          {
            required: true,
            trigger: "change",
            message: "Year is required.",
          },
        ],
        card_code: [
          {
            required: true,
            trigger: "blur",
            message: "Security code(CVV/CVC) is required.",
          },
        ],
      },
      dialogTitle: 'Booking Online',
      tips: null
    };
  },
  async created() {
    var year = (new Date()).getFullYear();
    var yearOptions = [];
    for (let i = 0; i <= 20; i++) {
      yearOptions.push(year + i)
    }
    this.yearOptions = yearOptions;

    var width = window.innerWidth;
    // console.log("width", width);
    var nowDate = new Date();
    // this.book_date = moment(nowDate).format("YYYY-MM-DD");
    this.getColorTypeList();
    // this.getTableclothColor();
    // this.getBookConfig();
  },
  methods: {
    changeMonthYear() {
      if (this.payform.month && this.payform.year) {
        var expiration_date = this.payform.year + '-' + (this.payform.month > 9 ? this.payform.month : `0${this.payform.month}`);
        var date = moment(new Date()).format('YYYY-MM');
        // 选择的日期
        var date1 = new Date(expiration_date + '-01T00:00:00');
        // 今天的日期
        var date2 = new Date(date + '-01T00:00:00');
        if (date1 < date2) {
          this.tips = 'expiration date error';
        } else {
          this.tips = null;
        }
      } else {
        this.tips = null;
      }
    },
    getTaxes(type) {
      var subtotal = 0;
      var orgPrice = 0;
      if (this.activity_discount.discount || this.orgPaymentTotal != this.paymentTotal) {
        if (this.form.payment_id.indexOf('deposit') > -1) {
          subtotal = (Number(this.getPartyPrice() || 0) + Number(this.paymentTotal || 0)).toFixed(2);
        } else {
          subtotal = (Number(this.getPartyPrice() || 0) * ((100 -
            (this.activity_discount.discount || 0)) /
            100).toFixed(2) + Number(this.paymentTotal || 0)).toFixed(2)
        }
        if (this.form.payment_id.indexOf('deposit') == -1 || (this.orgPaymentTotal != this.paymentTotal)) {
          orgPrice = (Number(this.getPartyPrice()) + Number(this.orgPaymentTotal)).toFixed(2)
        }
      } else {
        subtotal = (Number(this.getPartyPrice()) + Number(this.orgPaymentTotal)).toFixed(2)
      }

      var tax = (subtotal * Number(this.config.tax_rate) / 100).toFixed(2);

      var total = (Number(subtotal) + Number(tax)).toFixed(2);
      if(type == 'Taxes') {
        return tax;
      }
      if (type == 'total') {
        return total;
      }
    },
    formatPhoneNumberInfo(value) {
      const digits = value.replace(/\D/g, '');
      if (digits.length > 6) {
        this.form.phone = `(${digits.slice(0, 3)})${digits.slice(3, 6)}-${digits.slice(6)}`;
      } else if (digits.length > 3 && digits.length <= 6) {
        this.form.phone = `(${digits.slice(0, 3)})${digits.slice(3)}`;
      } else {
        this.form.phone = digits;
      }
    },
    handleInput(value) {
      var numReg = /^[0-9]*$/;
      var lastText = value.substring(value.length - 1, value.length);
      if (!numReg.test(lastText)) {
        var lastValue = this.formatPhoneNumber(
          value.substring(0, value.length - 1)
        );
        this.form.phone = lastValue;
      } else {
        this.form.phone = this.formatPhoneNumber(value);
      }
    },
    validatePhone(rule, value, callback) {
      if (value && value.length < 13) {
        callback(new Error('Please check your phone number.'));
      }
      if (!value) {
        callback(new Error('phone number is required'));
      }
      callback();
    },
    formatPhoneNumber(phoneNumber) {
      if (
        phoneNumber.length < 5 &&
        phoneNumber[0] == "(" &&
        phoneNumber[phoneNumber.length - 2] != ")" &&
        phoneNumber[phoneNumber.length - 1] != ")"
      ) {
        phoneNumber = `(${phoneNumber.substring(
          1,
          phoneNumber[phoneNumber.length - 1]
        )})`;
      }
      phoneNumber = phoneNumber
        .replace("(", "")
        .replace(")", "")
        .replace("-", "");

      if (phoneNumber.length > 3 && phoneNumber.length <= 6) {
        var num1 = phoneNumber.substring(0, 3);
        var num2 = phoneNumber.substring(3, phoneNumber.length);
        return `(${num1})${num2}`;
      } else if (phoneNumber.length <= 3 && phoneNumber.length > 0) {
        return `(${phoneNumber})`;
      } else if (phoneNumber.length == 0) {
        return "";
      } else {
        var num1 = phoneNumber.substring(0, 3);
        var num2 = phoneNumber.substring(3, 6);
        var num3 = phoneNumber.substring(6, phoneNumber.length);
        return `(${num1})${num2}-${num3}`;
      }
    },
    changeDate(value) {
      // var date = moment(value).format("YYYY-MM-DD");
      if(value) {
        var date = moment_timezone.tz(value, 'US/Mountain').format("YYYY-MM-DD");
        this.book_date = date;
        this.book_date_mm = moment_timezone.tz(value, 'US/Mountain').format("MM/DD/yyyy");
        this.getRoomList(this.checkTabKey);
        this.getProductService();
        this.getBookConfig();
        this.checkId = null;
        this.checkTimeId = null;
      }
    },
    async getColorTypeList() {
      try {
        const { status, data } = await colorTypeList({});
        if (status == 0) {
          for (let i = 0; i <= data.items.length - 1; i++) {
            data.items[i].color = data.items[i].bg_color ? data.items[i].bg_color : this.colorOrgList[(i + 1) % 3];
          }
          this.colorTitleList = data.items;
          // this.checkTabKey = data[0].key;
          // this.color = data[0].color;
          // this.getRoomList(data[0].key);
        }
      } catch (error) { }
    },
    async getBookConfig() {
      try {
        const { status, data } = await bookConfig({
          party_package_id: this.checkTabKey,
          book_date: this.book_date,
        });
        if (status == 0) {
          this.tableclothColorInfo = data.tablecloth_color;
          this.provideInfo = data.party_provide;
        }
      } catch (error) { }
    },
    getPartyPrice() {
      if (this.paymentInfo && this.paymentInfo.find(item => item.id == this.form.payment_id)) {
        return Number(this.paymentInfo.find(item => item.id == this.form.payment_id).price)
      } else {
        return 0
      }
    },
    getProvideInfoTitle() {
      if (this.provideInfo.find(item => item.id == this.form.party_provide_id)) {
        return this.provideInfo.find(item => item.id == this.form.party_provide_id).title
      }
    },
    getTableclothColorInfoColor() {
      if (this.tableclothColorInfo.find(item => item.id == this.form.tablecloth_color_id)) {
        return this.tableclothColorInfo.find(item => item.id == this.form.tablecloth_color_id).color
      }
    },
    async getRoomList(params) {
      this.roomListInfo = [];
      this.block = null;
      if(!this.book_date) return
      try {
        const { status, data } = await roomList({
          party_package_id: params,
          book_date: this.book_date,
        });
        if (status == 0) {
          // this.roomListInfo = data;
          // for (let i = 0; i <= data.items.length - 1; i++) {
          //   data.items[i].children = [];
          //   for (let j = 0; j <= data.items[i].room_times.length - 1; j++) {
          //     data.items[i].children.push({
          //       id: data.items[i].room_times[j].id,
          //       is_calendar: data.items[i].room_times[j].is_calendar,
          //       time: data.items[i].room_times[j].time_text,
          //     });
          //   }
          // }
          // this.block = data.block;
          // this.roomListInfo = data.items;
          this.block = data.block;
          this.roomListInfo = data.new_data;
        }
      } catch (error) { }
    },
    async getProductService() {
      if (!this.book_date) return
      const { status, data } = await productServiceList({
        // date: '2024-10-22',
        // shop_id: 17,
        // party_package_id: 22,
        party_package_id: this.checkTabKey,
        date: this.book_date,
        shop_id: this.config.config_type
      });
      if (status == 0) {
        data.items.additional_service_list.map(item => item.num = 0);
        data.items.product_payment_list.map(item => item.num = 0);
        this.activity_discount = data.items.activity_discount;
        this.additional_service_list = data.items.additional_service_list;
        this.product_payment_list = data.items.product_payment_list;
      }
    },
    // 计算合计
    changeNum(val) {
      this.$nextTick(() => {
        // console.log("hhhhh", val, this.additional_service_list)
        var newAdditional_service_list = JSON.parse(JSON.stringify(this.additional_service_list))
        var newProduct_payment_list = JSON.parse(JSON.stringify(this.product_payment_list))
        var additionalTotal = 0;
        for (let i = 0; i <= newAdditional_service_list.length - 1; i++) {
          additionalTotal += (Number(newAdditional_service_list[i].price || 0) * (newAdditional_service_list[i].num || 0))
        }
        this.additionalTotal = additionalTotal.toFixed(2);

        var paymentTotal = 0;
        var orgPaymentTotal = 0;
        for (let i = 0; i <= newProduct_payment_list.length - 1; i++) {
          var newValue = 0;
          if (newProduct_payment_list[i].activity_discount && newProduct_payment_list[i].activity_discount.discount) {
            newValue = ((Number(newProduct_payment_list[i].price) * (100 - newProduct_payment_list[i].activity_discount.discount) / 100).toFixed(2)) * (newProduct_payment_list[i].num || 0)
          } else {
            newValue = newProduct_payment_list[i].price * (newProduct_payment_list[i].num || 0)
          }
          orgPaymentTotal += newProduct_payment_list[i].price * (newProduct_payment_list[i].num || 0);
          paymentTotal += newValue;
        }
        this.paymentTotal = paymentTotal.toFixed(2);
        this.orgPaymentTotal = orgPaymentTotal.toFixed(2);
      })
    },
    // checkTab
    checkTab(item) {
      this.detail = null;
      this.color = item.color;
      this.checkTabKey = item.id;
      this.paymentInfo = item.payment;
      this.form.payment_id = [];
      this.additionalTotal = 0;
      this.paymentTotal = 0;
      this.orgPaymentTotal = 0;
      this.checkId = null;
      if (this.book_date) {
        this.getRoomList(item.id);
        this.getBookConfig();
        this.getProductService();
      }
      this.detail = item;
    },
    handleClose() {
      this.close();
      this.$parent.closeDialog();
    },
    checkTime(citem, item) {
      // if (citem.is_calendar != 1) {
      //   this.checkId = item.id;
      //   this.checkTimeId = citem.id;
      // }
      this.checkId = item.id;
      this.checkTimeId = citem.id;
      this.checkTimeText = item.time_text;
    },
    close() {
      this.pageIndex = 1;
      this.dialogTitle = 'Booking Online';
      this.form = {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        payment_id: [],
        party_provide_id: null,
        tablecloth_color_id: null,
        birthday_child_name: "",
        remark: "",
      };
      this.checkId = null;
      this.checkTimeId = null;
      this.checkTabKey = null;
      this.roomListInfo = [];
      this.color = null;
      this.detail = null;
    },
    // next page
    async next(index) {
      if (index == 1) {
        if (this.checkTabKey == null) {
          this.$message.warning("Select Type");
          return;
        }
        if (this.checkTimeId == null) {
          this.$message.warning("Select Room");
          return;
        }
        this.$refs["form"].validate(async (valid) => {
          if (valid) {
            this.pageIndex = index + 1;
          }
        })
      } else {
        this.pageIndex = index + 1;
        if (this.pageIndex == 3) {
          this.dialogTitle = 'Payment method';
        }
      }
    },
    // Back
    Back(index) {
      this.pageIndex = index - 1;
      if (this.pageIndex == 3) {
        this.dialogTitle = 'Payment method';
      }
    },
    async submit() {
      if (this.checkTabKey == null) {
        this.$message.warning("Select Type");
        return;
      }
      if (!this.book_date) {
        this.$message.warning("Select Date");
        return;
      }
      if (!this.checkTimeId) {
        this.$message.warning("Select Room");
        return;
      }
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            this.$refs["payform"].validate(async (valid) => {
              if (valid) {
                this.form.remark = this.form.remark.replace(/^\s+|\s+$/g, '')
                var params = {
                  book_date: this.book_date,
                  party_package_id: this.checkTabKey,
                  room_id: this.checkId,
                  room_time_id: this.checkTimeId,
                  ...this.form,
                };
                var obj = {};


                obj.expiration_date = this.payform.year + '-' + (this.payform.month > 9 ? this.payform.month : `0${this.payform.month}`);
                var date = moment(new Date()).format('YYYY-MM');
                // 选择的日期
                var date1 = new Date(obj.expiration_date + '-01T00:00:00');
                // 今天的日期
                var date2 = new Date(date + '-01T00:00:00');
                if (date1 < date2) {
                  this.$message.warning("expiration date error");
                  this.loading = false;
                  return
                }

                if (this.activity_discount.id) {
                  obj.activity_discount_id = this.activity_discount.id;
                }

                var select_additional_service = this.additional_service_list.filter(item => item.num > 0);
                if (select_additional_service.length > 0) {
                  var list = [];
                  select_additional_service.map(item => {
                    list.push({
                      id: item.id,
                      quantity: item.num
                    })
                  })
                  obj.additional_service = list;
                }

                var select_product_payment = this.product_payment_list.filter(item => item.num > 0);
                if (select_product_payment.length > 0) {
                  var product_list = [];
                  select_product_payment.map(item => {
                    product_list.push({
                      id: item.id,
                      quantity: item.num,
                      activity_discount_id: item.activity_discount_id
                    })
                  })
                  obj.product_payment = product_list;
                }
                if(!params.remark) {
                  delete params.remark
                }
                const { status, data, msg } = await addBook({ ...params, ...obj, ...this.payform }).catch(error => {
                  this.loading = false;
                });
                if (status == 0) {
                  if (data == 1001) {
                    this.$message.warning('The room has been reserved!');
                  } else {
                    this.$message.success("success");
                    this.close();
                    this.$parent.closeDialog();
                  }
                  // this.$confirm(
                  //   `Booking for party on date ${data.book_date} ${data.time_text} requires a deposit payment of $${data.pay_price} to complete the booking. After payment is completed, a confirmation email will be sent to ${data.email}.`,
                  //   "PayInfo",
                  //   {
                  //     confirmButtonText: "Pay",
                  //     cancelButtonText: 'Cancel',
                  //   }
                  // )
                  //   .then(() => {
                  //     window.open(data.pay_url);
                  //   })
                  //   .catch(() => { });
                  // this.$alert(
                  //   `Booking for party on date ${data.book_date} ${data.time_text} requires a pre order payment of $${data.pay_price} to complete the booking. After payment is completed, a booking email will be sent to ${data.email}.`,
                  //   "PayInfo",
                  //   {
                  //     confirmButtonText: "Pay",
                  //     callback: (action) => {
                  //       window.open(data.pay_url);
                  //     },
                  //   }
                  // );
                } else {
                  this.$message.error(msg);
                }
                this.loading = false;
              }
            })
          } catch (error) { }
        }
      });
    },
  },
};
</script>

<style scoped>
.select-date-wrap {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.wrap {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 6px;
}

.colorWrap {
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  border: 1px solid #dee0e7;
  border-radius: 4px;
}

.color-item {
  border-right: 1px solid #dee0e7;
}

.color {
  padding: 8px;
  cursor: pointer;
  font-size: 16px;
}

.time-wrap {
  display: flex;
  border: 1px solid #e2e2e2;
  padding: 10px 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.time-sigle {
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #eee;
  text-align: center;
  cursor: pointer;
  margin: 4px;
}

.time-sigle .room_time {
  font-size: 14px;
  font-weight: bold;
  margin-top: 2px;
}

.time-title {
  border: 1px solid #e7e6e6;
  padding: 4px;
  margin: 8px 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 13px;
}

.no-wrap {
  word-break: break-word !important;
}

.active {
  color: #fff !important;
  background: #409eff;
}

/deep/ .el-form-item__label {
  width: 100px !important;
}

/deep/ .el-form-item__content {
  margin-left: 100px !important;
}

.pay_wrap /deep/ .el-form-item__label {
  width: 200px !important;
}

.pay_wrap /deep/ .el-form-item__content {
  margin-left: 200px !important;
}

.label_100 /deep/ .el-form-item__label {
  width: 100% !important;
  text-align: left;
}

.label_100 /deep/ .el-form-item__content {
  margin-left: 0px !important;
}

.provide /deep/ .el-radio {
  display: block;
}

.label_100 /deep/ .el-radio {
  padding: 10px 0;
}

.level-big {
  background: linear-gradient(-45deg, #de4c50, #f28859);
}

.LEVEL-DETAIL {
  color: #fff;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 9px 9px 19px #c9c9c9, -9px -9px 19px #fff;
  margin-bottom: 10px;
}

.level-name {
  font-size: 32px;
  line-height: 1;
  margin: 0.4em 0;
}

.HR {
  margin: 16px -0.25em;
  border: 1px solid;
}

.LEVEL-DETAIL div {
  line-height: 20px;
  white-space: pre-line;
}

/deep/ .el-calendar-table:not(.is-range) td.next,
.el-calendar-table:not(.is-range) td.prev {
  pointer-events: none;
}

/deep/ .el-calendar-table:not(.is-range) td.next {
  pointer-events: none;
}

/deep/ .el-calendar-table:not(.is-range) td.prev {
  pointer-events: none;
}

/deep/ .el-calendar-table:not(.is-range) td.current {
  pointer-events: none;
}

.book_btn {
  pointer-events: auto;
}

/deep/ .el-calendar__button-group {
  display: none;
}

.calendar-wrap /deep/ .el-calendar__header {
  display: none;
}

/deep/ .el-calendar-table .el-calendar-day {
  height: auto !important;
  padding: 0px !important;
}

.calendar-wrap /deep/ .el-button {
  padding: 5px 11px;
}

.query-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.time-area {
  min-height: 40px;
  padding: 4px;
}

.book-area {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 5px 0;
  border-top: 1px solid #f2f6fc;
}

.date {
  margin: 0 10px;
}

.tab_active {
  background: #409eff;
  color: #fff !important;
}

.is_calendar {
  cursor: not-allowed;
  background: #eee !important;
  color: #666 !important;
}

.html_info {
  white-space: pre-line;
}

.party {
  padding: 8px;
  margin: 1px;
  color: #fff;
  cursor: pointer;
  pointer-events: auto;
}

.level-small {
  background: linear-gradient(-45deg, #f36c31, #faca49);
}

.party_detail_wrap div {
  margin-bottom: 10px;
}

.flex_wrap {
  display: flex;
}

.flex_wrap div {
  flex: 1;
}

.mb-10 {
  margin-bottom: 10px;
}

.label_80 /deep/ .el-form-item__label {
  width: 80px !important;
}

.label_80 /deep/ .el-form-item__content {
  margin-left: 80px !important;
}

@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  .is-hidden-mobile-992 {
    display: none !important;
  }
}

@media screen and (min-width: 769px),
print {
  .is-hidden-tablet {
    display: none !important;
  }

  .child_name /deep/ .el-form-item__label {
    width: 190px !important;
  }

  .child_name /deep/ .el-form-item__content {
    margin-left: 190px !important;
  }
}

@media screen and (min-width: 993px),
print {
  .is-hidden-tablet-992 {
    display: none !important;
  }

  .child_name /deep/ .el-form-item__label {
    width: 190px !important;
  }

  .child_name /deep/ .el-form-item__content {
    margin-left: 190px !important;
  }
}

.block_wrap {
  height: 120px;
  color: white;
  background: #9FA0A4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.block_title {
  font-size: 20px;
  margin-bottom: 10px;
}

.block_tips {
  font-size: 16px;
}

.card-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 40px;
}

.card {
  border-radius: 0%;
  border: 1px solid #eee;
  padding: 10px;
  margin-top: 10px;
}

.card div {
  line-height: 30px;
}

.card-content {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex {
  display: flex;
}

.flex div {
  white-space: normal;
  line-height: 30px;
}

.text-r {
  text-align: right
}

.org_price {
  margin-left: 8px;
  text-decoration: line-through;
  font-weight: bold;
  color: black;
}

.LEVEL-DETAIL .org_price {
  color: white;
}

.discount {
  margin-left: auto;
  background: #e65137;
  color: white;
  margin-left: 8px;
  padding: 0px 6px;
  margin-right: 8px;
}

.discount_price_1 {
  margin-left: 5px;
}

.org_price_1 {
  margin-left: 5px;
  text-decoration: line-through;
  font-weight: bold;
  color: black;
}

.space_between {
  justify-content: space-between;
}

.tips {
  font-size: 12px;
}

.total {
  margin-top: 10px;
}

.total .title {
  font-size: 18px;
  font-weight: bold;
}

/deep/ .dialog-footer {
  display: block !important;
  padding: 10px 20px !important;
  text-align: right !important;
}

.ml10 {
  margin-left: 10px;
}

.time-sigle-disibled {
  background: #ccc;
  pointer-events: none;
}

.mb4 {
  margin-bottom: 4px;
}

@media screen and (min-width: 769px) {
  .scrollWrap {
    max-height: 400px;
    overflow-y: scroll;
    padding-right: 7px;
  }

  /*定义滚动条的整体样式使其变窄*/
  .scrollWrap::-webkit-scrollbar {
    width: 4px;
    height: 1px;
  }

  /*定义滚动条的滑块的样式有圆角和阴影以及自定义的背景色*/
  .scrollWrap::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #d3d5d6;
  }

  /*定义滚动条所在轨道的样式。有圆角和阴影以及淡色系的背景色*/
  .scrollWrap::-webkit-scrollbar-track {
    border-radius: 4px;
  }
}
.month_wrap /deep/ .el-form-item__content {
  margin-left: 0px !important;
}
.tips {
  color: red;
  font-size: 12px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Book.vue